/* ============================================================
   ARTLEAP — ヘッダーの検索（2026-09-23）
   入力しながら候補を出す。Shopify の /search/suggest.json を使うので
   アプリは不要。Enter または「すべての結果」で /search へ。
   ============================================================ */
(function () {
  'use strict';
  /* 画面の文言：layout/theme.liquid → snippets/i18n-js が window.__i18n.search に言語ごとの文言を入れる。無ければ日本語の既定（2026-10-25） */
  var I18N = (window.__i18n && window.__i18n.search) || {};
  function T(k, d) { var v = I18N[k]; return (v == null || v === '') ? d : v; }

  var panel = document.querySelector('[data-search-panel]');
  if (!panel) return;

  var input   = panel.querySelector('[data-search-input]');
  var results = panel.querySelector('[data-search-results]');
  var allLink = panel.querySelector('[data-search-all]');
  var empty   = panel.querySelector('[data-search-empty]');
  var opener  = document.querySelectorAll('[data-search-open]');
  var closer  = panel.querySelector('[data-search-close]');
  var form    = panel.querySelector('form');
  var last    = null;
  var timer   = null;
  var opened  = false;

  function open() {
    panel.hidden = false;
    opened = true;
    document.documentElement.style.overflow = 'hidden';
    window.setTimeout(function () { input.focus(); }, 30);
  }
  function close() {
    panel.hidden = true;
    opened = false;
    document.documentElement.style.overflow = '';
    if (last) { last.focus(); }
  }

  for (var i = 0; i < opener.length; i++) {
    (function (b) {
      b.addEventListener('click', function () { last = b; open(); });
    })(opener[i]);
  }
  if (closer) { closer.addEventListener('click', close); }
  panel.addEventListener('click', function (e) { if (e.target === panel) { close(); } });
  document.addEventListener('keydown', function (e) { if (opened && e.key === 'Escape') { close(); } });

  if (form) {
    form.addEventListener('submit', function (e) {
      if (!input.value.trim()) { e.preventDefault(); }
    });
  }

  function money(cents) {
    return '¥' + Math.round(cents / 100).toLocaleString('ja-JP');
  }

  function render(data, q) {
    var r = (data && data.resources && data.resources.results) || {};
    var products = r.products || [];
    var collections = r.collections || [];
    results.textContent = '';

    collections.forEach(function (c) {
      var a = document.createElement('a');
      a.className = 'srow';
      a.href = c.url;
      var ph = document.createElement('span');
      ph.className = 'srow__img';
      a.appendChild(ph);
      var t = document.createElement('div');
      t.className = 'srow__t';
      var em = document.createElement('em');
      em.textContent = T('collection_kind', '作家・展示・会場');
      t.appendChild(em);
      t.appendChild(document.createTextNode(c.title));
      a.appendChild(t);
      a.appendChild(document.createElement('span'));
      results.appendChild(a);
    });

    products.forEach(function (p) {
      var a = document.createElement('a');
      a.className = 'srow';
      a.href = p.url;
      if (p.featured_image && p.featured_image.url) {
        var im = document.createElement('img');
        im.className = 'srow__img';
        im.src = p.featured_image.url;
        im.alt = '';
        im.loading = 'lazy';
        a.appendChild(im);
      } else {
        var ph2 = document.createElement('span');
        ph2.className = 'srow__img';
        a.appendChild(ph2);
      }
      var t = document.createElement('div');
      t.className = 'srow__t';
      var em = document.createElement('em');
      em.textContent = p.vendor || '';
      t.appendChild(em);
      t.appendChild(document.createTextNode(p.title));
      a.appendChild(t);
      var pr = document.createElement('span');
      pr.className = 'srow__p';
      pr.textContent = p.available ? money(p.price) : ((p.tags || []).indexOf('upcoming') > -1 ? T('upcoming_prefix', '販売前・') + money(p.price) : '—');
      a.appendChild(pr);
      results.appendChild(a);
    });

    var none = !products.length && !collections.length;
    empty.hidden = !none;
    allLink.hidden = none;
    allLink.href = '/search?q=' + encodeURIComponent(q);
    allLink.textContent = T('see_all_results', '「{q}」のすべての結果を見る').replace('{q}', q);
  }

  function ask() {
    var q = input.value.trim();
    if (q.length < 1) {
      results.textContent = '';
      empty.hidden = true;
      allLink.hidden = true;
      return;
    }
    var url = '/search/suggest.json?q=' + encodeURIComponent(q) +
              '&resources[type]=product,collection&resources[limit]=6' +
              '&resources[options][unavailable_products]=last';
    fetch(url, { headers: { 'Accept': 'application/json' } })
      .then(function (res) { return res.json(); })
      .then(function (data) { render(data, q); })
      .catch(function () { /* 通信できないときは何も出さない。Enter で /search へ行ける */ });
  }

  input.addEventListener('input', function () {
    window.clearTimeout(timer);
    timer = window.setTimeout(ask, 180);
  });
})();
